var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportableSpills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1800_27200)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_27200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1800_27200)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1800_27200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.218 42.2797C54.8799 43.3778 56.5 44.9759 56.5 46.8824C56.5 50.4824 50.629 53 43.5 53C36.371 53 30.5 50.4824 30.5 46.8824C30.5 44.9759 32.1201 43.3778 34.782 42.2797C34.8665 41.8073 35.0233 41.3449 35.2521 40.91C35.6868 40.0839 35.6868 39.0926 35.2521 38.2664C34.5261 36.8867 34.5261 35.231 35.2521 33.8512C35.6868 33.0251 35.6868 32.0337 35.2521 31.2076C34.5261 29.8278 34.5261 28.1722 35.2521 26.7924C35.6868 25.9663 35.6868 24.9749 35.2521 24.1488L34.3235 22.3841C33.9936 21.7572 34.4419 21 35.1429 21H51.8571C52.5581 21 53.0064 21.7572 52.6765 22.3841L51.7479 24.1488C51.3132 24.9749 51.3132 25.9663 51.7479 26.7924C52.4739 28.1722 52.4739 29.8278 51.7479 31.2076C51.3132 32.0337 51.3132 33.0251 51.7479 33.8512C52.4739 35.231 52.4739 36.8867 51.7479 38.2664C51.3132 39.0926 51.3132 40.0839 51.7479 40.91C51.9767 41.3449 52.1335 41.8073 52.218 42.2797ZM34.8575 44.3021C33.2219 45.0933 32.3571 46.0369 32.3571 46.8824C32.3571 47.7402 33.1674 48.5979 34.5438 49.315L35.2521 47.9689C35.6868 47.1427 35.6868 46.1514 35.2521 45.3253C35.0795 44.9973 34.948 44.6538 34.8575 44.3021ZM52.4562 49.315C53.8326 48.5979 54.6429 47.7402 54.6429 46.8824C54.6429 46.0369 53.7781 45.0933 52.1425 44.3021C52.052 44.6538 51.9205 44.9973 51.7479 45.3253C51.3132 46.1514 51.3132 47.1427 51.7479 47.9689L52.4562 49.315ZM39.7857 24.7647V28.5294C39.7857 29.0492 40.2014 29.4706 40.7143 29.4706C41.2271 29.4706 41.6429 29.0492 41.6429 28.5294V24.7647C41.6429 24.2449 41.2271 23.8235 40.7143 23.8235C40.2014 23.8235 39.7857 24.2449 39.7857 24.7647ZM45.3571 31.3529V37.9412C45.3571 38.461 45.7729 38.8824 46.2857 38.8824C46.7985 38.8824 47.2143 38.461 47.2143 37.9412V31.3529C47.2143 30.8331 46.7985 30.4118 46.2857 30.4118C45.7729 30.4118 45.3571 30.8331 45.3571 31.3529ZM41.1786 41.7059V47.3529C41.1786 47.8727 41.5943 48.2941 42.1071 48.2941C42.62 48.2941 43.0357 47.8727 43.0357 47.3529V41.7059C43.0357 41.1861 42.62 40.7647 42.1071 40.7647C41.5943 40.7647 41.1786 41.1861 41.1786 41.7059Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1800_27200",
    x: 0.5,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1800_27200",
    x: 24.5,
    y: 19,
    width: 38,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1800_27200",
    x1: 43.5,
    y1: 12,
    x2: 43.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_27200"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportableSpills);
export default __webpack_public_path__ + "static/media/ReportableSpills.d0fc38e0427150e6be72f8a1fa6939f0.svg";
export { ForwardRef as ReactComponent };